module.exports = __webpack_public_path__ + "static/media/bahai.805c3eb9.svg";